export default __webpack_public_path__ + "static/media/Scroll down_W.6b8dd7f4.svg";